import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// The selected company, in the store — APP-1 (`TBS-47`).
//
// **It lives in Redux rather than only in `localStorage` because of who has to read it.** Every TBS
// API slice sets `X-Tenant-Id` inside `prepareHeaders`, which is a module-level closure created once
// at import: it cannot use a hook, and it already reaches for `getState()` to find the bearer token.
// Putting the company beside the token means the header is built from the same place, by the same
// mechanism, and a change is visible to every in-flight slice at once.
//
// `localStorage` is still where it survives a reload; this is where it is read.

interface TbsTenantState {
  /** Empty means "not chosen" — the authorizer then picks, which is only correct with one company. */
  tenantId: string;
}

const initialState: TbsTenantState = { tenantId: "" };

const tbsTenantSlice = createSlice({
  name: "tbsTenant",
  initialState,
  reducers: {
    setTbsTenant(state, action: PayloadAction<string>) {
      state.tenantId = action.payload;
    },
  },
});

export const { setTbsTenant } = tbsTenantSlice.actions;

export default tbsTenantSlice.reducer;
